/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SigningDropdownOptionViewModel } from './SigningDropdownOptionViewModel';
import {
    SigningDropdownOptionViewModelFromJSON,
    SigningDropdownOptionViewModelFromJSONTyped,
    SigningDropdownOptionViewModelToJSON,
} from './SigningDropdownOptionViewModel';

/**
 * 
 * @export
 * @interface SigningLookupsViewModel
 */
export interface SigningLookupsViewModel {
    /**
     * 
     * @type {Array<SigningDropdownOptionViewModel>}
     * @memberof SigningLookupsViewModel
     */
    signatoryRoleOptions: Array<SigningDropdownOptionViewModel>;
    /**
     * 
     * @type {Array<SigningDropdownOptionViewModel>}
     * @memberof SigningLookupsViewModel
     */
    consultantRoleOptions: Array<SigningDropdownOptionViewModel>;
    /**
     * 
     * @type {Array<SigningDropdownOptionViewModel>}
     * @memberof SigningLookupsViewModel
     */
    documentTypeOptions: Array<SigningDropdownOptionViewModel>;
    /**
     * 
     * @type {Array<SigningDropdownOptionViewModel>}
     * @memberof SigningLookupsViewModel
     */
    mimeTypes: Array<SigningDropdownOptionViewModel>;
    /**
     * 
     * @type {Array<SigningDropdownOptionViewModel>}
     * @memberof SigningLookupsViewModel
     */
    countryDialingCodes: Array<SigningDropdownOptionViewModel>;
}

/**
 * Check if a given object implements the SigningLookupsViewModel interface.
 */
export function instanceOfSigningLookupsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "signatoryRoleOptions" in value;
    isInstance = isInstance && "consultantRoleOptions" in value;
    isInstance = isInstance && "documentTypeOptions" in value;
    isInstance = isInstance && "mimeTypes" in value;
    isInstance = isInstance && "countryDialingCodes" in value;

    return isInstance;
}

export function SigningLookupsViewModelFromJSON(json: any): SigningLookupsViewModel {
    return SigningLookupsViewModelFromJSONTyped(json, false);
}

export function SigningLookupsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigningLookupsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signatoryRoleOptions': ((json['SignatoryRoleOptions'] as Array<any>).map(SigningDropdownOptionViewModelFromJSON)),
        'consultantRoleOptions': ((json['ConsultantRoleOptions'] as Array<any>).map(SigningDropdownOptionViewModelFromJSON)),
        'documentTypeOptions': ((json['DocumentTypeOptions'] as Array<any>).map(SigningDropdownOptionViewModelFromJSON)),
        'mimeTypes': ((json['MimeTypes'] as Array<any>).map(SigningDropdownOptionViewModelFromJSON)),
        'countryDialingCodes': ((json['CountryDialingCodes'] as Array<any>).map(SigningDropdownOptionViewModelFromJSON)),
    };
}

export function SigningLookupsViewModelToJSON(value?: SigningLookupsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'SignatoryRoleOptions': ((value.signatoryRoleOptions as Array<any>).map(SigningDropdownOptionViewModelToJSON)),
        'ConsultantRoleOptions': ((value.consultantRoleOptions as Array<any>).map(SigningDropdownOptionViewModelToJSON)),
        'DocumentTypeOptions': ((value.documentTypeOptions as Array<any>).map(SigningDropdownOptionViewModelToJSON)),
        'MimeTypes': ((value.mimeTypes as Array<any>).map(SigningDropdownOptionViewModelToJSON)),
        'CountryDialingCodes': ((value.countryDialingCodes as Array<any>).map(SigningDropdownOptionViewModelToJSON)),
    };
}

